export enum LeadFormProductsEnum {
	ZFT = 'MamaFit',
	SGT = 'Small Group Training',
	PGT = 'Private Group Training',
	PT = 'Personal Training',
	Duo = 'Duo Training',
	SgtTrial = 'Small Group Training Proefles',
}
